import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Common.css';

const Terms = ({ onNavigate }) => {
  const handleContactClick = () => {
    if (onNavigate) {
      onNavigate('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="terms-page">
      {/* Header Section */}
      <section className="contact-header-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="contact-main-title">Terms & Conditions</h1>
              <p className="contact-subtitle">
                By opting in to receive SMS messages, you agree to the following:
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-12">

              {/* Section 1 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">1. Consent for SMS Communication</h2>
                <p className="terms-text">
                  Phone numbers obtained during the SMS consent process will not be shared with third parties for marketing purposes. This ensures your information is used solely for communication purposes related to our services.
                </p>
              </div>

              {/* Section 2 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">2. Types of SMS Communications</h2>
                <p className="terms-text mb-3">
                  By opting in, you may receive SMS messages related to:
                </p>
                <ul className="terms-list">
                  <li>Appointment reminders</li>
                  <li>Follow-up messages</li>
                  <li>Billing inquiries</li>
                  <li>Promotions or offers (if applicable)</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">3. Message Frequency</h2>
                <p className="terms-text">
                  Message frequency may vary depending on the type of communication. For example, you may receive up to 15 messages per week related to appointments, billing, etc.
                </p>
              </div>

              {/* Section 4 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">4. Potential Fees for SMS Messaging</h2>
                <p className="terms-text">
                  Standard message and data rates may apply, depending on your carrier’s pricing plan. These fees may differ for domestic or international messages.
                </p>
              </div>

              {/* Section 5 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">5. Opt-In Methods</h2>
                <p className="terms-text mb-3">
                  You may opt in to receive SMS messages from Ortho Med Products in the following ways:
                </p>
                <ul className="terms-list">
                  <li>By submitting an online form at Contact Us.</li>
                  <li>By filling out a paper form at our clinic located at Ortho Med Products, 11 Elkins Rd, East Brunswick, NJ 08816</li>
                </ul>
              </div>

              {/* Section 6 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">6. Opt-Out Instructions</h2>
                <p className="terms-text mb-3">
                  You can opt out at any time by replying “STOP” to any SMS message. Alternatively, contact us directly at
                  <a href="mailto:info@orthomedonline.com" className="email-link"> info@orthomedonline.com</a>.
                </p>
              </div>

              {/* Section 7 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">7. Help</h2>
                <p className="terms-text">
                  If you are experiencing any issues, reply with the keyword “HELP” or contact us at
                  <a href="mailto:info@orthomedonline.com" className="email-link"> info@orthomedonline.com</a>.
                </p>
              </div>

              {/* Section 8 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">8. Additional Options</h2>
                <p className="terms-text">
                 If you do not wish to receive SMS messages, do not check the SMS consent box on our forms.
                </p>
              </div>

              {/* Section 9 */}
              <div className="terms-section mb-5">
                <h2 className="section-heading">9. Standard Messaging Disclosures</h2>
                <p className="terms-text">
                  Message and data rates may apply.
                </p>
                <p className="terms-text">
                  You can opt out at any time by replying "STOP".
                </p>
                <p className="terms-text">
                  For assistance, text “HELP” or visit our Privacy Policy.
                </p>
                <p className="terms-text">
                  Message frequency may vary depending on service.
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0">
                <h3 className="cta-title">Contact us today to learn more about our products.</h3>
              </div>
              <div className="col-lg-4 text-lg-end">
                <button className="btn-cta" onClick={handleContactClick}>
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;